import dayjs from 'dayjs';

import { type IDateRange } from '../model';

const DAYS_BACK: Record<IDateRange, number> = {
  today: 0,
  last_2_days: 1,
  last_7_days: 7,
  last_30_days: 30,
};

export const computeCreatedAfter = (dateRange: IDateRange): string =>
  dayjs().subtract(DAYS_BACK[dateRange], 'day').format('YYYY-MM-DD');
